import { ReactNode } from 'react';

import Rail from './Rail';

/**
 * Every signed-in page inside the sections rail: the rail down the left
 * edge on desktop, the page moved right by its width (--sig-rail-w, which is
 * 0 on phones and wherever the rail is not drawn). Public views (a shared
 * thread, the login) stay outside it.
 */
export default function Shell({ children }: { children: ReactNode }) {
  return (
    <>
      <Rail />
      <div className="md:pl-[var(--sig-rail-w)]">{children}</div>
    </>
  );
}
